import React, {useState} from 'react';
import './AirbnbPage.css';

/* ─── Wobbly SVG borders (same pattern as MSNPage) ── */
function SketchRect({className, children}: { className?: string; children?: React.ReactNode }) {
    return (
        <div className={`sketch-box ${className || ''}`}>
            <svg className="sketch-box__border" viewBox="0 0 400 300" preserveAspectRatio="none">
                <path
                    d="M18,8 C90,5 200,10 382,8 C386,10 390,14 392,18 C394,80 390,200 392,282 C390,286 386,290 382,292 C280,295 100,290 18,292 C14,290 10,286 8,282 C6,180 10,60 8,18 C10,14 14,10 18,8 Z"
                    fill="none" stroke="#222" strokeWidth="2.5"
                />
            </svg>
            <div className="sketch-box__content">{children}</div>
        </div>
    );
}

function SketchRectInput({className, children}: { className?: string; children?: React.ReactNode }) {
    return (
        <div className={`sketch-box ${className || ''}`}>
            <svg className="sketch-box__border" viewBox="0 0 400 100" preserveAspectRatio="none">
                <path
                    d="M20,6 C120,4 280,8 380,6 C385,9 389,14 391,20 C393,40 390,65 392,80 C390,85 385,90 380,93 C260,95 140,92 20,94 C15,91 11,86 9,80 C7,55 10,30 8,20 C10,14 15,9 20,6 Z"
                    fill="none" stroke="#222" strokeWidth="2.5"
                />
            </svg>
            <div className="sketch-box__content">{children}</div>
        </div>
    );
}

function SketchSquare({className, children}: { className?: string; children?: React.ReactNode }) {
    return (
        <div className={`sketch-square ${className || ''}`}>
            <svg className="sketch-square__border" viewBox="0 0 100 100" preserveAspectRatio="none">
                <path
                    d="M12,6 C30,4 70,8 88,6 C92,9 96,13 97,18 C99,40 96,70 98,82 C96,87 92,92 88,94 C65,96 35,93 12,95 C8,92 5,87 4,82 C3,55 5,30 3,18 C5,13 8,9 12,6 Z"
                    fill="none" stroke="#222" strokeWidth="2.8"
                />
            </svg>
            <div className="sketch-square__content">{children}</div>
        </div>
    );
}

/* ─── Sketch SVG icons ────────────────────────────── */
function IconSearch() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2.2" strokeLinecap="round">
            <circle cx="10.5" cy="10.5" r="6.5"/>
            <line x1="15.5" y1="15.5" x2="21" y2="21"/>
        </svg>
    );
}

function IconBed() {
    return (
        <svg className="airbnb-info__icon" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round">
            <path d="M3,18 L3,12 C3,10 5,8 8,8 L16,8 C19,8 21,10 21,12 L21,18"/>
            <path d="M3,12 L21,12"/>
            <line x1="3" y1="18" x2="3" y2="20"/>
            <line x1="21" y1="18" x2="21" y2="20"/>
            <rect x="6" y="5" width="4" height="3" rx="1"/>
            <rect x="14" y="5" width="4" height="3" rx="1"/>
        </svg>
    );
}

function IconPeople() {
    return (
        <svg className="airbnb-info__icon" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2"
             strokeLinecap="round">
            <circle cx="9" cy="7" r="3"/>
            <path d="M3,20 C3,16 6,13 9,13 C12,13 15,16 15,20"/>
            <circle cx="17" cy="9" r="2.5"/>
            <path d="M15,20 C15,17 16.5,14.5 17,14.5 C19,14.5 21,17 21,20"/>
        </svg>
    );
}

function IconPin() {
    return (
        <svg className="airbnb-info__icon" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2"
             strokeLinecap="round">
            <path d="M12,2 C8,2 5,5.5 5,9 C5,14 12,22 12,22 C12,22 19,14 19,9 C19,5.5 16,2 12,2 Z"/>
            <circle cx="12" cy="9" r="2.5"/>
        </svg>
    );
}

function IconKey() {
    return (
        <svg className="airbnb-info__icon" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2"
             strokeLinecap="round">
            <circle cx="8" cy="15" r="5"/>
            <line x1="12" y1="11" x2="21" y2="3"/>
            <line x1="18" y1="3" x2="21" y2="6"/>
            <line x1="16" y1="7" x2="18" y2="9"/>
        </svg>
    );
}

function IconClock() {
    return (
        <svg className="airbnb-info__icon" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2"
             strokeLinecap="round">
            <circle cx="12" cy="12" r="9"/>
            <polyline points="12,7 12,12 16,14"/>
        </svg>
    );
}

/* ─── Illustration SVGs ───────────────────────────── */
function IllusBuilding() {
    return (
        <svg className="airbnb-illus" viewBox="0 0 80 80" fill="none" stroke="#222" strokeWidth="1.8"
             strokeLinecap="round" strokeLinejoin="round">
            {/* Building outline */}
            <path d="M20,72 L20,15 C20,13 22,12 25,12 L55,12 C58,12 60,13 60,15 L60,72"/>
            {/* Roof line */}
            <path d="M16,72 L64,72"/>
            {/* Windows */}
            <rect x="27" y="18" width="8" height="8" rx="1"/>
            <rect x="45" y="18" width="8" height="8" rx="1"/>
            <rect x="27" y="32" width="8" height="8" rx="1"/>
            <rect x="45" y="32" width="8" height="8" rx="1"/>
            <rect x="27" y="46" width="8" height="8" rx="1"/>
            <rect x="45" y="46" width="8" height="8" rx="1"/>
            {/* Door */}
            <rect x="35" y="58" width="10" height="14" rx="1"/>
            <circle cx="43" cy="66" r="1" fill="#222"/>
        </svg>
    );
}

function IllusCouch() {
    return (
        <svg className="airbnb-illus" viewBox="0 0 80 80" fill="none" stroke="#222" strokeWidth="1.8"
             strokeLinecap="round" strokeLinejoin="round">
            {/* Couch back */}
            <path d="M12,30 C12,24 16,20 22,20 L58,20 C64,20 68,24 68,30 L68,45 L12,45 Z"/>
            {/* Seat */}
            <path d="M8,45 L72,45 L72,55 C72,58 70,60 67,60 L13,60 C10,60 8,58 8,55 Z"/>
            {/* Armrests */}
            <path d="M8,35 C5,35 3,38 3,42 L3,50 C3,52 5,54 8,54"/>
            <path d="M72,35 C75,35 77,38 77,42 L77,50 C77,52 75,54 72,54"/>
            {/* Legs */}
            <line x1="15" y1="60" x2="15" y2="66"/>
            <line x1="65" y1="60" x2="65" y2="66"/>
            {/* Cushion line */}
            <line x1="40" y1="45" x2="40" y2="58"/>
        </svg>
    );
}

function IllusSuite() {
    return (
        <svg className="airbnb-illus" viewBox="0 0 80 80" fill="none" stroke="#222" strokeWidth="1.8"
             strokeLinecap="round" strokeLinejoin="round">
            {/* Bed frame */}
            <rect x="10" y="35" width="60" height="30" rx="3"/>
            {/* Headboard */}
            <path d="M10,35 L10,18 C10,15 14,12 20,12 L60,12 C66,12 70,15 70,18 L70,35"/>
            {/* Pillows */}
            <rect x="16" y="38" width="18" height="10" rx="3" strokeWidth="1.4"/>
            <rect x="46" y="38" width="18" height="10" rx="3" strokeWidth="1.4"/>
            {/* Blanket fold */}
            <path d="M14,52 C28,50 52,50 66,52" strokeWidth="1.2"/>
            {/* Heart on headboard */}
            <path d="M36,22 C36,19 40,16 40,20 C40,16 44,19 44,22 C44,25 40,28 40,28 C40,28 36,25 36,22 Z"
                  strokeWidth="1.2" fill="#e53935" stroke="#e53935"/>
            {/* Legs */}
            <line x1="14" y1="65" x2="14" y2="70"/>
            <line x1="66" y1="65" x2="66" y2="70"/>
        </svg>
    );
}

/* Category sketch icons */
function CatDortoir() {
    return (
        <svg className="airbnb-category__icon" viewBox="0 0 32 32" fill="none" stroke="#222" strokeWidth="1.5"
             strokeLinecap="round" strokeLinejoin="round">
            {/* Diamond top */}
            <polygon points="16,4 27,13 16,28 5,13"/>
            {/* Crown facets */}
            <line x1="5" y1="13" x2="27" y2="13"/>
            <line x1="11" y1="13" x2="16" y2="4"/>
            <line x1="21" y1="13" x2="16" y2="4"/>
            {/* Lower facets */}
            <line x1="11" y1="13" x2="16" y2="28"/>
            <line x1="21" y1="13" x2="16" y2="28"/>
        </svg>
    );
}

function CatMeme() {
    return (
        <svg className="airbnb-category__icon" viewBox="0 0 32 32" fill="none" stroke="#222" strokeWidth="1.5"
             strokeLinecap="round" strokeLinejoin="round">
            {/* Building outline */}
            <path d="M8,28 L8,8 C8,7 9,6 11,6 L21,6 C23,6 24,7 24,8 L24,28"/>
            {/* Ground line */}
            <line x1="6" y1="28" x2="26" y2="28"/>
            {/* Windows */}
            <rect x="11" y="9" width="3.5" height="3.5" rx="0.5"/>
            <rect x="17.5" y="9" width="3.5" height="3.5" rx="0.5"/>
            <rect x="11" y="15.5" width="3.5" height="3.5" rx="0.5"/>
            <rect x="17.5" y="15.5" width="3.5" height="3.5" rx="0.5"/>
            {/* Door */}
            <rect x="13.5" y="22" width="5" height="6" rx="0.5"/>
            <circle cx="17" cy="25.5" r="0.6" fill="#222"/>
        </svg>
    );
}

function CatCanape() {
    return (
        <svg className="airbnb-category__icon" viewBox="0 0 32 32" fill="none" stroke="#222" strokeWidth="1.5"
             strokeLinecap="round" strokeLinejoin="round">
            <path d="M7,15 C7,12 9,10 12,10 L20,10 C23,10 25,12 25,15 L25,19 L7,19 Z"/>
            <path d="M5,16 C4,16 3,17 3,19 L3,21 C3,22 4,23 5,23"/>
            <path d="M27,16 C28,16 29,17 29,19 L29,21 C29,22 28,23 27,23"/>
            <path d="M5,23 L27,23"/>
            <line x1="9" y1="23" x2="9" y2="26"/>
            <line x1="23" y1="23" x2="23" y2="26"/>
        </svg>
    );
}

function CatSuite() {
    return (
        <svg className="airbnb-category__icon" viewBox="0 0 32 32" fill="none" stroke="#222" strokeWidth="1.5"
             strokeLinecap="round">
            <rect x="6" y="14" width="20" height="12" rx="2"/>
            <path d="M6,14 L6,9 C6,7 9,5 16,5 C23,5 26,7 26,9 L26,14"/>
            <path d="M13,10 C13,8 16,6 16,9 C16,6 19,8 19,10 C19,12 16,14 16,14 C16,14 13,12 13,10 Z" strokeWidth="1.2"
                  fill="#e53935" stroke="#e53935"/>
        </svg>
    );
}

/* ─── Star SVG ────────────────────────────────────── */
function SketchStar({filled}: { filled: boolean }) {
    return (
        <svg className={`airbnb-review__star ${filled ? 'airbnb-review__star--filled' : ''}`}
             viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="1.8" strokeLinecap="round"
             strokeLinejoin="round">
            <path
                d="M12,2 L14.9,8.6 L22,9.3 L16.8,14 L18.2,21 L12,17.5 L5.8,21 L7.2,14 L2,9.3 L9.1,8.6 Z"
                fill={filled ? '#222' : 'none'}
                strokeDasharray={filled ? '200' : '0'}
                strokeDashoffset="0"
            />
        </svg>
    );
}

/* ─── Data ────────────────────────────────────────── */
interface Logement {
    type: 'chambre' | 'appart';
    nom: string;
    hote?: string;
    adresse?: string;
    mapsUrl?: string;
    codeAcces?: string;
    colocataires: string[];
    fakeReview: string;
    fakeRating: number;
    checkIn?: string;
    checkOut?: string;
    illustration: 'bunk' | 'building' | 'couch' | 'suite';
}

const LOGEMENTS: Record<string, Logement> = {
    'dortoir-1': {
        type: 'chambre',
        nom: 'Suite nuptiale',
        colocataires: ['Juliette B.', 'Édouard'],
        fakeReview: "L'insonorisation est parfaite, le verrou est très appréciable pour profiter en toute intimité.",
        fakeRating: 5,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-2': {
        type: 'chambre',
        nom: 'Women in a chAEmbre',
        colocataires: ['Isis', 'Camille', 'Pauline', 'Loanne'],
        fakeReview: "Très calme si on oublie le fou rire de 6h du mat.",
        fakeRating: 5,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-3': {
        type: 'chambre',
        nom: 'Hoplé Bang Bang',
        colocataires: ['Audrey', 'Lucas', 'Alice', 'Jean', 'Matthieu'],
        fakeReview: "Plus confort que mon dernier auto-tour !",
        fakeRating: 4,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-4': {
        type: 'chambre',
        nom: 'Les Girlz',
        colocataires: ['Isaure', 'Juliette'],
        fakeReview: "Parfait pour faire des rencontres !",
        fakeRating: 5,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-5': {
        type: 'chambre',
        nom: 'l\'EHPAD',
        colocataires: ['Luka', 'Maxence', 'Simon'],
        fakeReview: "Cap sur la séniorité !",
        fakeRating: 3,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-6': {
        type: 'chambre',
        nom: 'Les ingénieurs (du son)',
        colocataires: ['Juliette W.', 'Florian', 'Augustin', 'Victorien'],
        fakeReview: "Désolé Juliette on se rapproche plus du camionneur que de l'ingé.",
        fakeRating: 1,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-7': {
        type: 'chambre',
        nom: 'Le studio X',
        colocataires: ['Juliette D.', 'Baptiste'],
        fakeReview: "Souriez vous êtes filmés !",
        fakeRating: 5,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'dortoir-8': {
        type: 'chambre',
        nom: 'Le Dortoir',
        colocataires: ['Antoine', 'Âmes égarées'],
        fakeReview: "50% de chance d'être tout seul, 50% de chance d'être assez pour une belote.",
        fakeRating: 2,
        checkIn: 'Après 5h.',
        checkOut: 'Avant 11h.',
        illustration: 'bunk',
    },
    'appart-raph': {
        type: 'appart',
        nom: 'Chez Tata Raph',
        hote: 'Raphaëlle',
        adresse: '48 rue de la Folie Méricourt, Paris 11e',
        mapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=48+Rue+de+la+Folie+Mericourt+Paris',
        codeAcces: 'Digicode: 84AB9 puis AB567 — 3ème étage face',
        colocataires: ['Peggy', 'Evelyne', 'Michel'],
        fakeReview: "Appartement confort et coloré. Le cadre parfait pour se faire passer pour un bobo parisien.",
        fakeRating: 5,
        checkIn: 'Après minuit.',
        checkOut: 'Avant 13h.',
        illustration: 'building',
    },
    'appart-isaure': {
        type: 'appart',
        nom: 'Chez Tata Isaure',
        hote: 'Isaure',
        adresse: '12 rue d\'Aix, Paris 10e',
        mapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=12+Rue+dAix+Paris',
        codeAcces: 'Code: 98B52 — 2ème étage droite',
        colocataires: ['Priscille', 'Étienne'],
        fakeReview: 'Appart très cosy mais ne comptez pas sur le détecteur de fumées.',
        fakeRating: 5,
        checkIn: 'Après minuit.',
        checkOut: 'Avant 13h.',
        illustration: 'building',
    },
    'appart-nous': {
        type: 'appart',
        nom: 'Chez les PACSÉS',
        hote: 'Juliette & Édouard',
        adresse: '24 rue des Batignolles, Paris 17e',
        mapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=24+Rue+des+Batignolles+Paris',
        codeAcces: 'Code: 61A2 — 6ème étage gauche - sans ascenseur',
        colocataires: ['Sandrine', 'Jean-Christophe'],
        fakeReview: 'Ascension de difficulté modérée, voire difficile en état d\'ébriété mais la vue en vaut la peine !',
        fakeRating: 5,
        checkIn: 'Après minuit.',
        checkOut: 'Avant 13h.',
        illustration: 'building',
    },
};

const GUESTS: Record<string, string> = {
    'Juliette B.': 'dortoir-1',
    'Édouard': 'dortoir-1',
    'Isis': 'dortoir-2',
    'Camille': 'dortoir-2',
    'Loanne': 'dortoir-2',
    'Pauline': 'dortoir-2',
    'Audrey': 'dortoir-3',
    'Lucas': 'dortoir-3',
    'Jean': 'dortoir-3',
    'Alice': 'dortoir-3',
    'Matthieu': 'dortoir-3',
    'Isaure': 'dortoir-4',
    'Juliette A.': 'dortoir-4',
    'Simon': 'dortoir-5',
    'Luka': 'dortoir-5',
    'Maxence': 'dortoir-5',
    'Florian': 'dortoir-6',
    'Juliette W.': 'dortoir-6',
    'Augustin': 'dortoir-6',
    'Victorien': 'dortoir-6',
    'Juliette D.': 'dortoir-7',
    'Baptiste': 'dortoir-7',
    'Antoine': 'dortoir-8',
    'Peggy': 'appart-raph',
    'Evelyne': 'appart-raph',
    'Michel': 'appart-raph',
    'Priscille': 'appart-isaure',
    'Étienne': 'appart-isaure',
    'Sandrine': 'appart-nous',
    'Jean-Christophe': 'appart-nous'
};

/* Normalize: lowercase + strip accents */
function normalize(s: string): string {
    return s.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/* Fuzzy match: checks if all characters of the query appear in order in the target */
function fuzzyMatch(query: string, target: string): { match: boolean; score: number } {
    const q = normalize(query);
    const t = normalize(target);
    if (!q) return {match: false, score: 0};

    let qi = 0;
    let score = 0;
    let consecutive = 0;

    for (let ti = 0; ti < t.length && qi < q.length; ti++) {
        if (t[ti] === q[qi]) {
            qi++;
            consecutive++;
            score += consecutive;                // reward consecutive matches
            if (ti === qi - 1) score += 2;       // reward matching from start
        } else {
            consecutive = 0;
        }
    }

    return {match: qi === q.length, score};
}

/* Get fuzzy-matched guest names, sorted by best score */
function searchGuests(query: string): Array<{ name: string; logementId: string }> {
    if (!query.trim()) return [];

    const results: Array<{ name: string; logementId: string; score: number }> = [];

    for (const [guestName, logementId] of Object.entries(GUESTS)) {
        const {match, score} = fuzzyMatch(query, guestName);
        if (match) {
            /* Capitalize first letter for display */
            const displayName = guestName.charAt(0).toUpperCase() + guestName.slice(1);
            results.push({name: displayName, logementId, score});
        }
    }

    results.sort((a, b) => b.score - a.score);
    return results;
}

/* Illustration component picker */
function Illustration({type}: { type: string }) {
    switch (type) {
        case 'bunk':
            return <img src="/bedroom1.jpg" alt="Chambre" className="airbnb-illus-img"/>;
        case 'building':
            return <IllusBuilding/>;
        case 'couch':
            return <IllusCouch/>;
        case 'suite':
            return <IllusSuite/>;
        default:
            return <img src="/bedroom1.jpg" alt="Chambre" className="airbnb-illus-img"/>;
    }
}

/* ═══════════════════════════════════════════════════
   AirbnbPage component
   ═══════════════════════════════════════════════════ */
export default function AirbnbPage() {
    const [phase, setPhase] = useState<'search' | 'result'>('search');
    const [query, setQuery] = useState('');
    const [logement, setLogement] = useState<Logement | null>(null);

    const suggestions = searchGuests(query);

    function selectGuest(logementId: string) {
        setLogement(LOGEMENTS[logementId]);
        setPhase('result');
    }

    function handleKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter' && suggestions.length > 0) {
            selectGuest(suggestions[0].logementId);
        }
    }

    function handleBack() {
        setPhase('search');
        setQuery('');
        setLogement(null);
    }

    /* ─── Search screen ─── */
    if (phase === 'search') {
        const hasQuery = query.trim().length > 0;
        const noResults = hasQuery && suggestions.length === 0;

        return (
            <div className="airbnb-page">
                <div className="airbnb-search">
                    {/* Aligned column: logo + input + dropdown + categories */}
                    <div className="airbnb-search__column">
                        <div className="airbnb-search__logo">
                            <span className="airbnb-search__logo-accent">a</span>irbnb
                        </div>

                        <div className="airbnb-searchbar">
                            <div className="airbnb-searchbar__field">
                                <SketchRectInput>
                                    <input
                                        className="airbnb-searchbar__input"
                                        type="text"
                                        placeholder="Rentre ton prénom et découvre où tu dors, et avec qui !"
                                        value={query}
                                        onChange={e => setQuery(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        autoFocus
                                    />
                                </SketchRectInput>

                                {/* Floating suggestions — anchored on field only */}
                                {suggestions.length > 0 && (
                                    <div className="airbnb-suggestions">
                                        {suggestions.map(s => {
                                            const log = LOGEMENTS[s.logementId];
                                            return (
                                                <button
                                                    key={s.name}
                                                    className="airbnb-suggestion"
                                                    onClick={() => selectGuest(s.logementId)}
                                                >
                                                    <span className="airbnb-suggestion__name">{s.name}</span>
                                                    <span className="airbnb-suggestion__logement">{log.nom}</span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                            {/* Button positioned absolutely, outside the aligned column */}
                            <button
                                className="airbnb-searchbar__btn"
                                onClick={() => suggestions.length > 0 && selectGuest(suggestions[0].logementId)}
                                aria-label="Rechercher"
                            >
                                <IconSearch/>
                            </button>
                        </div>

                        {noResults && (
                            <div className="airbnb-notfound" key={query}>
                                Hmm, t'es pas sur la liste... T'es sûr·e que t'es invité·e ?
                            </div>
                        )}

                        <div className="airbnb-categories">
                            <div className="airbnb-category">
                                <CatDortoir/>
                                <span className="airbnb-category__label">Dortoir de luxe</span>
                            </div>
                            <div className="airbnb-category">
                                <CatMeme/>
                                <span className="airbnb-category__label">Chez mémé</span>
                            </div>
                            <div className="airbnb-category">
                                <CatCanape/>
                                <span className="airbnb-category__label">Canape premium</span>
                            </div>
                            <div className="airbnb-category">
                                <CatSuite/>
                                <span className="airbnb-category__label">Suite nuptiale</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /* ─── Result screen ─── */
    if (!logement) return null;

    return (
        <div className="airbnb-page">
            <div className="airbnb-result">
                <button className="airbnb-back" onClick={handleBack}>
                    &#8592; Nouvelle recherche
                </button>

                {/* Header: illustration + title */}
                <div className="airbnb-header">
                    <div className="airbnb-header__illustration">
                        <SketchSquare>
                            <Illustration type={logement.illustration}/>
                        </SketchSquare>
                    </div>

                    <div className="airbnb-header__info">
                        <div className="airbnb-header__title">{logement.nom}</div>
                        {logement.hote && (
                            <div className="airbnb-header__host">Proposé par {logement.hote}</div>
                        )}
                        <div className="airbnb-header__type">
                            {logement.type === 'chambre' ? 'Chambre partagée — sur place' : 'Appartement entier — Paris'}
                        </div>
                    </div>
                </div>

                {/* Review */}
                <div className="airbnb-review">
                    <div className="airbnb-review__stars">
                        {[1, 2, 3, 4, 5].map(n => (
                            <SketchStar key={n} filled={n <= logement.fakeRating}/>
                        ))}
                    </div>
                    <div className="airbnb-review__text">"{logement.fakeReview}"</div>
                </div>

                {/* Info blocks */}
                <div className={`airbnb-infos${logement.type === 'appart' ? ' airbnb-infos--grid' : ''}`}>
                    <div className="airbnb-info">
                        <IconPeople/>
                        <div className="airbnb-info__content">
                            <div className="airbnb-info__label">Colocataires</div>
                            <div className="airbnb-info__value">{logement.colocataires.join(', ')}</div>
                        </div>
                    </div>

                    {logement.adresse && (
                        <div className="airbnb-info">
                            <IconPin/>
                            <div className="airbnb-info__content">
                                <div className="airbnb-info__label">Adresse</div>
                                <div className="airbnb-info__value">
                                    {logement.mapsUrl ? (
                                        <a href={logement.mapsUrl} target="_blank" rel="noopener noreferrer"
                                           className="airbnb-info__link">
                                            {logement.adresse}
                                        </a>
                                    ) : logement.adresse}
                                </div>
                            </div>
                        </div>
                    )}

                    {logement.codeAcces && (
                        <div className="airbnb-info">
                            <IconKey/>
                            <div className="airbnb-info__content">
                                <div className="airbnb-info__label">Accès</div>
                                <div className="airbnb-info__value">{logement.codeAcces}</div>
                            </div>
                        </div>
                    )}

                    {(logement.checkIn || logement.checkOut) && (
                        <div className="airbnb-info">
                            <IconClock/>
                            <div className="airbnb-info__content">
                                <div className="airbnb-info__label">Horaires</div>
                                <div className="airbnb-info__value">
                                    {logement.checkIn && <>Check-in : {logement.checkIn}<br/></>}
                                    {logement.checkOut && <>Check-out : {logement.checkOut}</>}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Reserve button */}
                <div className="airbnb-reserve">
                    <button className="airbnb-reserve__btn" disabled>
                        Réserver
                    </button>
                    <div className="airbnb-reserve__sub">Déjà réservé pour toi ;)</div>
                </div>
            </div>
        </div>
    );
}
